import { config } from '../../config';
import { EmbeddedMessagingService } from '@gig/magic-messaging/dist/components/salesforce-messaging';

export const salesforceMessaging: EmbeddedMessagingService | null =
    config.salesforceMessaging
        ? new EmbeddedMessagingService(config.salesforceMessaging)
        : null;
